<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.budget')"
    icon="res-budget"
    :res-name="detailData.name"
    :actions="params.actions"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :data="detailData"
      :res-id="data.id"
      :id="listId"
      :listId="listId"
      :on-manager="onManager"
      :getParams="getParams"
      :hideTitleActions="true"
      :hideRecordList="true"
      :hiddenColumns="hiddenColumns"
      @side-page-trigger-handle="sidePageTriggerHandle"
      @init-side-page-tab="initSidePageTab"
      @single-refresh="singleRefresh" />
  </base-side-page>
</template>

<script>
import AlertRecord from '@Monitor/views/alertrecord/components/List'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import BudgetListDetail from './Detail'
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BudgetListSidePage',
  components: {
    Actions,
    BudgetListDetail,
    AlertRecord,
  },
  mixins: [WindowsMixin, SidePageMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.text_185'), key: 'budget-list-detail' },
        { label: this.$t('bill.alert_record'), key: 'alert-record' },
        { label: this.$t('bill.text_186'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'event-drawer':
          return 'EventListForBudgetListSidePage'
        case 'alert-record':
          return 'BudgetAlertRecordListSidePage'
        default:
          return ''
      }
    },
    getParams () {
      if (this.params.windowData.currentTab === 'alert-record') {
        const { alerts = [] } = this.detailData
        const { monitor_alert_id = 'none' } = alerts[0] || {}
        return {
          scope: this.$store.getters.scope,
          alert_id: monitor_alert_id,
          used_by: 'cost',
        }
      }
      return {}
    },
    hiddenColumns () {
      if (this.params.windowData.currentTab === 'alert-record') {
        return ['alert_name', 'type', 'level', 'res_type']
      }
      return []
    },
  },
}
</script>
